// '.alert.alert-auto-hide' のフラッシュを delay ミリ秒後にフェードアウトして消す。
// application.js を読まないページ(SEO ジャンルページ)用。挙動は customs/layout.js の FlashMessages(turbo:load 起点)と同じ。
export function autoHideFlashMessages({ doc = document, delay = 5000, fadeMs = 500 } = {}) {
  setTimeout(() => {
    doc.querySelectorAll(".alert.alert-auto-hide").forEach((flashMessage) => {
      flashMessage.style.transition = `opacity ${fadeMs / 1000}s ease-out`
      flashMessage.style.opacity = "0"
      setTimeout(() => flashMessage.remove(), fadeMs)
    })
  }, delay)
}
